import { useEffect, useState } from "react";
import PieChart from "../../../charts/PieChart";
import axiosInstance from "../../../../../services/AxiosInstance";
import { ApiError } from "../../../Common/ApiError";
import Api from "../../../../../constants/Api";
import { getDateRange } from "../../../../../utils/DateUtils";

const PotPieChart = (props) => {

    
    const { width, height, month, year, branchId, refreshKey, data: suppliedData, labels: suppliedLabels } = props;
    const [loadedData, setLoadedData] = useState([]);
    const [loadedLabels, setLoadedLabels] = useState([]);

    useEffect(() => {
        // O dashboard já traz estes dados junto com o rateio. A chamada permanece como
        // fallback para outros locais que ainda usam o gráfico isoladamente.
        if (suppliedData) {
            return;
        }
        const dateRange = getDateRange(month, year);
        axiosInstance.get(`${Api.sales.visual_chart}/pot/interval/${dateRange.start}/${dateRange.end}/score`, {
            params: {
                branchId
            }
        })
        .then((resp) => {
            setLoadedData(resp.data.data);
            setLoadedLabels(resp.data.labels);
        })
        .catch(error => ApiError(error));
    }, [month, year, branchId, refreshKey, suppliedData]);

    return (
        <PieChart
            width={width}
            height={height}
            data={suppliedData || loadedData}
            labels={suppliedLabels || loadedLabels}
        />
    );
}

export default PotPieChart;
